import React from "react";
import "./InsideVVCMS.css";

// ✅ Add your images here (update path/filename as per your project)
import PrincipalImage from "../assets/principal-image.jpeg";
const InsideVVCMS = () => {
  return (
    <div className="section inside-vvcms-section" data-aos="fade-up">
      {/* Vision & Mission Section */}
      <div className="vm-row vm-row--vision-mission">
        <div className="vm-text" data-aos="fade-left">
          <h3 className="vm-heading">Vision</h3>
          <p className="vm-desc">
            To inspire young minds to learn, explore, and excel through innovation,
            imagination and creative thinking.
          </p>

          <h3 className="vm-heading vm-heading--mission">Mission</h3>
          <p className="vm-desc">
            Our mission is to provide a safe, inclusive and stimulating learning
            environment that nurtures curiosity, creativity and critical thinking.
            We strive to empower every child with strong academic foundations,
            essential life skills and ethical values, enabling them to become
            confident, responsible, mindful and innovative global citizens.
          </p>
        </div>
      </div>

      {/* 100 YEARS LEGACY TIMELINE */}
      <section className="legacy-section" id="legacy">
        <h3 className="legacy-title">A Century-Plus of Pride</h3>
        <p className="legacy-subtitle">
          Vivek Vardhini Educational Society, a 114-year-old institution, has shaped
          generations through its dedication to education and cultural heritage.
        </p>

        <div className="legacy-timeline">
          <div className="legacy-line" />
          {[
            {
              year: "1907",
              title: "Foundation of Vivek Vardhini Educational Society",
              text: "Pandit Sripad Damodar Satwalekar, Dharmaveer Waman Naik, Justice Keshav Rao Koratkar, and others pooled their efforts and established the Vivek Vardhini Education Society on 25th October 1907 in Hyderabad.",
            },
            {
              year: "2007",
              title: "Centenary Celebrations",
              text: "The Centenary Celebrations were inaugurated by Bharat Ratna Dr. A.P.J. Abdul Kalam on 29th June 2007. Shri Rameshwar Thakur (Governor of Andhra Pradesh) and Dr. Y.S. Rajsekhar Reddy (Chief Minister) graced the event. Dr. Kalam also inaugurated a photo gallery depicting the society's history.",
            },
            {
              year: "2024",
              title: "114 Years of Legacy",
              text: "The society has grown into a sturdy oak tree with 19 institutions, offering education from KG to PG and research levels in English, Marathi, and Telugu, catering to more than 7,000 students.",
            },
          ].map((item, index) => (
            <div
              key={item.year}
              className={`legacy-item ${
                index % 2 === 0 ? "legacy-item--left" : "legacy-item--right"
              } ${item.image ? "legacy-item--with-image" : ""}`}
              data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
            >
              <div className="legacy-dot" />
              {item.image && (
                <div className="legacy-item-image">
                  <img src={item.image} alt={item.imageAlt || item.title} />
                </div>
              )}
              <div
                className={`legacy-card ${
                  item.image ? "legacy-card--with-image" : ""
                }`}
              >
                <div className="legacy-year">{item.year}</div>
                <div className="legacy-card-title">{item.title}</div>
                <p className="legacy-text">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ✅ PRINCIPAL'S DESK */}
      <section className="principal-section" id="principal" data-aos="fade-up">
        <h3 className="principal-title">Principal's Desk</h3>

        <div className="principal-card" data-aos="fade-up" data-aos-delay="150">
        <div className="leadership-image">
                  <img src={PrincipalImage} alt="SHRI. NAGESH.V. RAO" />
                </div>
          <div className="principal-content">
            <h4 className="principal-name">KANAMATHAREDDY SRIDHAR REDDY</h4>
            <p className="principal-role">
              Qualification :- M. Sc, B.Ed
            </p>

            <p className="principal-text">
              KANAMATHAREDDY SRIDHAR REDDY is a distinguished transformational Pedagogical
              Leader, Curriculum designer and Master trainer known for his visionary
              leadership and innovation-driven approach to future-ready education.
              An M.Sc. Mathematics and B.Ed. graduate from Osmania University,
              Hyderabad. He brings over three decades of experience in CBSE
              education, with teacher professional development and quality assurance.
              His educational philosophy seamlessly integrates scholastic excellence
              with co-scholastic enrichment, placing strong emphasis on experiential
              learning, 21st-century skills, life skills to nurture confident,
              resilient and ethical learners.
            </p>

            <p className="principal-text">
              His professional journey includes serving at Bharatiya Vidya Bhavan
              Jubilee Hills Hyderabad (1995–2008) as a Senior Grade Mathematics
              Teacher, where his innovative methodologies earned two National Awards
              from TCS and Scholastic Ltd. an International Award from the British
              Council and Regional award from CBSE. He later led Scholars
              International School (2008–2025) as Founder Principal, driving
              sustained institutional growth through collaborative leadership and
              strong parent partnerships.
            </p>

            <p className="principal-text">
              A Recognised CBSE Resource Person since 2005, he has contributed as a
              CBSE Inspection Panel Member, Drafting Committee Member for the Health
              Promoting School Manual and Affiliation Guidelines Manual. He took up
              responsibilities of Centre Superentendent for CBSE exams, Head Examiner
              for Grade X examination and as a Lead Collaborator for Hubs of Learning
              mentoring a cluster of seven schools.
            </p>

            <p className="principal-text">
              In 2025 he joined VVCMS as Founder Principal, steering the school
              towards global standards, innovation and holistic student development.
            </p>

            {/* ✅ NEW: Principal's Advice to Students */}
            <h5 className="principal-advice-title">
              Principal's Advice to the Students
            </h5>
            <p className="principal-advice-text">
              With a visionary approach to education, at VVCMS, I believe that
              “Every Child is UNIQUE” and deserves opportunities to explore, learn
              and grow with joy. Igniting young minds to think creatively and learn
              meaningfully is a key responsibility, as learning is nurtured to be
              inclusive, engaging and future-ready at all levels. My aim is to
              shape today’s learners into mindful and responsible citizens who
              understand the value of fulfilling duties before demanding rights and
              take pride in our rich culture and heritage. As a school deeply
              rooted in society with a glorious legacy of over 100 years, where
              many great visionaries have walked and left lasting legacies, this
              journey of excellence continues by nurturing many more leaders of
              tomorrow. The guiding motto remains to make every learner a proud
              Vivian of Vivek Vardhini Creative Minds School.
            </p>
          </div>
        </div>
      </section>

      {/* School Culture & Philosophy */}
      <section className="inside-block school-culture-section" data-aos="fade-up">
        <h3 className="school-culture-title">School Culture & Philosophy</h3>
        <p>
          At Vivek Vardhini Creative Minds School, we believe education is a journey
          that nurtures the mind, heart, and character. Our culture is rooted in
          full-spectrum learning, ensuring every child thrives academically,
          creatively, and socially. We emphasize core values—integrity, respect,
          compassion, and responsibility—which guide students to become
          conscientious and empathetic individuals. We strive for academic
          excellence while celebrating inclusivity and diversity, creating a safe
          and welcoming environment where every student feels valued. By fostering
          a spirit of lifelong learning, we inspire curiosity, resilience, and the
          courage to explore new ideas. Innovation and growth are at the heart of
          our approach, empowering students to think critically, solve problems,
          and adapt to an ever-changing world. Finally, we cherish community and
          relationships, building strong bonds among students, teachers, and
          parents, and nurturing responsible global citizens who contribute
          positively to society. At Vivek Vardhini Creative Minds School, learning
          goes beyond textbooks—it is a way of life.
        </p>
      </section>
    </div>
  );
};

export default InsideVVCMS;
